import { render, staticRenderFns } from "./PluginDetailsTraining.vue?vue&type=template&id=d09aca32"
import script from "./PluginDetailsTraining.vue?vue&type=script&lang=js"
export * from "./PluginDetailsTraining.vue?vue&type=script&lang=js"
import style0 from "./PluginDetailsTraining.vue?vue&type=style&index=0&id=d09aca32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports